import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../environments/environment';
import { storeFreeze } from 'ngrx-store-freeze';
import { combineReducers } from '@ngrx/store';
import * as fromCore from './modules/core/reducers';
import * as fromDocument from './modules/document/reducers';
import {localStorageSync} from 'ngrx-store-localstorage';
import * as fromRouter from '@ngrx/router-store';
import {RouterStateUrl} from './app.router-state';

export interface State {
  router: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = {
  router: fromRouter.routerReducer
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({keys: [
    'core',
    'document',
    'irar'
  ], rehydrate: true,
storage: sessionStorage})(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];


export const getAuthFullName = fromCore.getAuthFullName;
export const getAuthLoggedIn = fromCore.getAuthLoggedIn;
export const getAuthIsAdmin = fromCore.getAuthIsAdmin;
export const getAuthIsSuperAdmin = fromCore.getAuthIsSuperAdmin;
export const getAuthIsAliasing = fromCore.getAuthIsAliasing;
export const getAuthRole = fromCore.getAuthRole;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/app.reducer.ts